import React from "react";
import "./AdFlow.css";
import { Container, Row, Col, Card } from "react-bootstrap";
import { ArrowDown, ArrowRight } from "react-bootstrap-icons";
import "bootstrap/dist/css/bootstrap.min.css";

function AdFlow() {
  return (
    <Container className="adflow-container">
      {/* <div className="text-center adflow-step">
        <Card className="adflow-card">
          <Card.Body className="p-0">
            <Card.Title>First</Card.Title>
            <Card.Text>
              <span className="highlight">20</span>
              <br />
              <span className="bold">Second Ad</span>
              <br />
              <p>introduces your brand with a punch</p>
            </Card.Text>
          </Card.Body>
        </Card>
        <div className="arrow-wrapper">
          <ArrowRight className="arrow-icon d-none d-lg-inline" />
          <ArrowDown className="arrow-icon d-inline d-lg-none" />
        </div>
      </div>

      <div className="text-center adflow-step">
        <Card className="adflow-card">
          <Card.Body className="p-0">
            <Card.Title>Next</Card.Title>
            <Card.Text>
              <span className="highlight">20</span>
              <br />
              <span className="bold"> Seconds it shows </span>
              <br />
              <span className="bold">Real-time Bus Arrival Info</span>
              <br />
              <p>to grab and hold passenger’s attention.</p>
            </Card.Text>
          </Card.Body>
        </Card>
        <div className="arrow-wrapper">
          <ArrowRight className="arrow-icon d-none d-lg-inline" />
          <ArrowDown className="arrow-icon d-inline d-lg-none" />
        </div>
      </div>

      <div className="text-center adflow-step">
        <Card className="adflow-card">
          <Card.Body className="p-0">
            <Card.Title>Then, Another</Card.Title>
            <Card.Text>
              <span className="highlight">20</span>
              <br />
              <span className="bold">Second Ad</span>
              <br />
              <p>to reinforce your message.</p>
            </Card.Text>
          </Card.Body>
        </Card>

        <div className="arrow-wrapper">
          <ArrowRight className="arrow-icon d-none d-lg-inline" />
          <ArrowDown className="arrow-icon d-inline d-lg-none" />
        </div>
      </div>

      <div className="text-center adflow-step">
        <Card className="adflow-card">
          <Card.Body className="p-0">
            <Card.Title>Next</Card.Title>
            <Card.Text>
              <span className="highlight"> 20 </span>
              <br />
              <span className="bold"> Seconds</span>
              <br />
              <span className="bold"> Real-time bus arrival </span>
              <br />
              <p>info again to keep passengers engaged.</p>
            </Card.Text>
          </Card.Body>
        </Card>
      </div> */}

      <div className="row justify-content-center">
        <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
          <div className="text-center adflow-step box animate fadeInUp one">
            <Card className="adflow-card">
              <Card.Body className="p-0">
                <div>
                  <Card.Title>First</Card.Title>
                  <Card.Text>
                    {/* <span className="highlight">20</span>
                    <br /> */}
                    <h4 className="bold">Advertisement</h4>
                    <br />
                    <p>Introduces your brand with a punch.</p>
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
          <div className="text-center adflow-step box animate fadeInDown two">
            <Card className="adflow-card">
              <Card.Body className="p-0">
                <div>
                  <Card.Title>Next</Card.Title>
                  <Card.Text>
                    {/* <span className="highlight">20</span>
                    <br /> */}
                    {/* <span className="bold"> Seconds it shows </span>
                    <br /> */}
                    <h4 className="bold">LIVE ETA</h4>
                    <br />
                    <p>
                      Displays real-time bus arrival info to grab and hold
                      passengers’ attention.
                    </p>
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
          <div className="text-center adflow-step box animate fadeInLeft three">
            <Card className="adflow-card">
              <Card.Body className="p-0">
                <div>
                  <Card.Title>THEN, ANOTHER</Card.Title>
                  <Card.Text>
                    {/* <span className="highlight">20</span>
                    <br /> */}
                    <h4 className="bold">Advertisement</h4>
                    <br />
                    <p>Reinforces your message.</p>
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
          <div className="text-center adflow-step box animate fadeInRight four">
            <Card className="adflow-card">
              <Card.Body className="p-0">
                <div>
                  <Card.Title>AGAIN, NEXT</Card.Title>
                  <Card.Text>
                    {/* <span className="highlight"> 20 </span>
                    <br /> */}
                    <h4 className="bold"> LIVE ETA</h4>
                    <br />
                    <p>
                      {" "}
                      Real-time bus arrival info to keep passengers engaged.{" "}
                    </p>
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>

        <div className="col-12">
          <div className="note_holder">
            <p>This cycle continues, keeping passengers engaged.</p>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default AdFlow;
